var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _descriptor45, _descriptor46, _descriptor47, _descriptor48, _descriptor49, _descriptor50;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import environment from '@square/environment-utils/environment';
import Service, { inject as service } from '@ember/service';
import { readOnly } from '@ember/object/computed';
import { assert } from '@ember/debug';
import { tracked } from '@glimmer/tracking';

// The back-end inserts these props into current user data to mark where rails
// permissions start/end. Any props between them are added to this service.
const START_MARKER_PROP = 'startRailsPermissions';
const END_MARKER_PROP = 'endRailsPermissions';

/**
 * https://github.com/squareup/dashboard/blob/main/app/helpers/computed_permissions_helper.rb#L202
 */
let UserRailsPermissions = (_dec = readOnly('currentUserData.data'), (_class = class UserRailsPermissions extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "currentUserData", _descriptor, this);
    _initializerDefineProperty(this, "data", _descriptor2, this);
    _initializerDefineProperty(this, "canUseCardOnFile", _descriptor3, this);
    _initializerDefineProperty(this, "canUseDeviceHub", _descriptor4, this);
    _initializerDefineProperty(this, "canSeePointOfSaleNavigation", _descriptor5, this);
    _initializerDefineProperty(this, "canUsePrinterProfiles", _descriptor6, this);
    _initializerDefineProperty(this, "canUsePrinterProfilesNoRstOrRtl", _descriptor7, this);
    _initializerDefineProperty(this, "canUseDeviceHubNoRstOrRtl", _descriptor8, this);
    _initializerDefineProperty(this, "canSeeProductStore", _descriptor9, this);
    _initializerDefineProperty(this, "canUseDeviceProfilesV2", _descriptor10, this);
    _initializerDefineProperty(this, "canUseDeviceProfilesV2SoftGa", _descriptor11, this);
    _initializerDefineProperty(this, "canUseDeviceProfilesV2FullGa", _descriptor12, this);
    _initializerDefineProperty(this, "canUseDeviceProfilesV1FullGa", _descriptor13, this);
    _initializerDefineProperty(this, "canUseAposDeviceProfilesV2FullGa", _descriptor14, this);
    _initializerDefineProperty(this, "canUseRstDeviceProfilesV2FullGa", _descriptor15, this);
    _initializerDefineProperty(this, "canUseKioskDeviceProfilesV2FullGa", _descriptor16, this);
    _initializerDefineProperty(this, "canUseRtlDeviceProfilesV2FullGa", _descriptor17, this);
    _initializerDefineProperty(this, "canUseKdsDeviceProfilesV2FullGa", _descriptor18, this);
    _initializerDefineProperty(this, "canUseSposDeviceProfilesV2FullGa", _descriptor19, this);
    _initializerDefineProperty(this, "canUseIposDeviceProfilesV2FullGa", _descriptor20, this);
    _initializerDefineProperty(this, "shouldUseDpv1WDpv2ForMultiposInFullGa", _descriptor21, this);
    _initializerDefineProperty(this, "canSeeKdsUpsellWDpv2", _descriptor22, this);
    _initializerDefineProperty(this, "canUseSuperpos", _descriptor23, this);
    _initializerDefineProperty(this, "canViewEmployeePermissions", _descriptor24, this);
    _initializerDefineProperty(this, "canHasCompletedPayrollOnboarding", _descriptor25, this);
    _initializerDefineProperty(this, "isEcomMerchant", _descriptor26, this);
    _initializerDefineProperty(this, "canSeeBasicRestaurantsFeatures", _descriptor27, this);
    _initializerDefineProperty(this, "canAccessCommsAnnouncements", _descriptor28, this);
    _initializerDefineProperty(this, "canAccessCommsSettings", _descriptor29, this);
    _initializerDefineProperty(this, "canSeeInvoices", _descriptor30, this);
    _initializerDefineProperty(this, "canSeeInvoicesCustomizationTab", _descriptor31, this);
    _initializerDefineProperty(this, "canSeeInvoicesEstimateDefaultsTab", _descriptor32, this);
    _initializerDefineProperty(this, "canSeeInvoicesSettingsTabs", _descriptor33, this);
    _initializerDefineProperty(this, "canSeeSellerProjects", _descriptor34, this);
    _initializerDefineProperty(this, "hasJoinedAppointments", _descriptor35, this);
    _initializerDefineProperty(this, "canUseMessenger", _descriptor36, this);
    _initializerDefineProperty(this, "canSeeReleaseManager", _descriptor37, this);
    _initializerDefineProperty(this, "canUseSquareStaff", _descriptor38, this);
    _initializerDefineProperty(this, "canSeeStaffPackagesExperiment", _descriptor39, this);
    _initializerDefineProperty(this, "isStaffPlansEligible", _descriptor40, this);
    _initializerDefineProperty(this, "canSeeAfterpayAbout", _descriptor41, this);
    _initializerDefineProperty(this, "canSeeAfterpayShop", _descriptor42, this);
    _initializerDefineProperty(this, "canManageTeamMemberFiles", _descriptor43, this);
    _initializerDefineProperty(this, "canManageTeamMemberOnboarding", _descriptor44, this);
    _initializerDefineProperty(this, "canViewTeamMemberFiles", _descriptor45, this);
    _initializerDefineProperty(this, "canSeeServiceLibrary", _descriptor46, this);
    _initializerDefineProperty(this, "canSeeItemDefaultSettings", _descriptor47, this);
    _initializerDefineProperty(this, "isCostPlusMerchant", _descriptor48, this);
    _initializerDefineProperty(this, "isInterchangePlusMerchant", _descriptor49, this);
    _initializerDefineProperty(this, "canSeeConnectedTerminalProfiles", _descriptor50, this);
    const keys = Object.keys(this.data) || [];
    const startIndex = keys.indexOf(START_MARKER_PROP) + 1;
    const endIndex = keys.indexOf(END_MARKER_PROP) - 1;
    if (startIndex >= endIndex && !environment().isTesting) {
      // this should Never Happen™, but if it does then the data is meaningless
      assert('Current user data does not have start/end marker props for rails permissions');
    }

    // hashtable object with string keys and boolean values
    const props = {};
    for (let i = startIndex; i <= endIndex; i++) {
      const key = keys[i];
      props[key] = this.data[key];
    }

    // yes, this is cheating typescript
    Object.assign(this, props);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "currentUserData", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "data", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "canUseCardOnFile", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "canUseDeviceHub", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "canSeePointOfSaleNavigation", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "canUsePrinterProfiles", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "canUsePrinterProfilesNoRstOrRtl", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "canUseDeviceHubNoRstOrRtl", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "canSeeProductStore", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "canUseDeviceProfilesV2", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "canUseDeviceProfilesV2SoftGa", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "canUseDeviceProfilesV2FullGa", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "canUseDeviceProfilesV1FullGa", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "canUseAposDeviceProfilesV2FullGa", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "canUseRstDeviceProfilesV2FullGa", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "canUseKioskDeviceProfilesV2FullGa", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "canUseRtlDeviceProfilesV2FullGa", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "canUseKdsDeviceProfilesV2FullGa", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "canUseSposDeviceProfilesV2FullGa", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "canUseIposDeviceProfilesV2FullGa", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "shouldUseDpv1WDpv2ForMultiposInFullGa", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "canSeeKdsUpsellWDpv2", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "canUseSuperpos", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "canViewEmployeePermissions", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "canHasCompletedPayrollOnboarding", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "isEcomMerchant", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "canSeeBasicRestaurantsFeatures", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "canAccessCommsAnnouncements", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "canAccessCommsSettings", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "canSeeInvoices", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "canSeeInvoicesCustomizationTab", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "canSeeInvoicesEstimateDefaultsTab", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "canSeeInvoicesSettingsTabs", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "canSeeSellerProjects", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "hasJoinedAppointments", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "canUseMessenger", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "canSeeReleaseManager", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "canUseSquareStaff", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "canSeeStaffPackagesExperiment", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "isStaffPlansEligible", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "canSeeAfterpayAbout", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "canSeeAfterpayShop", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "canManageTeamMemberFiles", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor44 = _applyDecoratedDescriptor(_class.prototype, "canManageTeamMemberOnboarding", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor45 = _applyDecoratedDescriptor(_class.prototype, "canViewTeamMemberFiles", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor46 = _applyDecoratedDescriptor(_class.prototype, "canSeeServiceLibrary", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor47 = _applyDecoratedDescriptor(_class.prototype, "canSeeItemDefaultSettings", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor48 = _applyDecoratedDescriptor(_class.prototype, "isCostPlusMerchant", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor49 = _applyDecoratedDescriptor(_class.prototype, "isInterchangePlusMerchant", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor50 = _applyDecoratedDescriptor(_class.prototype, "canSeeConnectedTerminalProfiles", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class));
export { UserRailsPermissions as default }; // DO NOT DELETE: this is how TypeScript knows how to look up your services.